
import { AppUserState } from "../stores/states/app.state";
import { WebArticle } from "./web-article";

export interface Tag {
  uuid: string;
  value: string;
  color: string;
  loading?: boolean;
}

export enum BoardStage {
  DRAFT = 'draft',
  IN_REVIEW = 'in-review',
  COMPLETED = 'completed',
}
export interface Board extends BoardHeader {
  chat?: BoardChatMsg[];
  notes?: BoardNote[];
  articles?: WebArticle[];
  calendarActivities?: any[];
  relevantKeys?: string[];
  summary?: string;
}
export interface BoardHeader {
  boardUUID: string;
  title: string;
  stage: BoardStage;
  ownerUUID: string;
  ownerSettings?: any;
  members: AppUserState[] | undefined;
  membersSubs?: string[];
  tags?: Tag[];
  articleCount?: number;
  articleRef?: string[];
  calendarActivitiesCount?: number;
  calendarActivitiesRef?: string[];
  createDate?: number;

}
export interface NewBoard {
  title: string;
  stage: BoardStage;
  owner: AppUserState;
  articles?: WebArticle[];
  calendarActivities?: any[];
}


export interface BoardColumn {
  id: string;
  title: string;
  stage: BoardStage;
  boards?: Board[];
}
export interface BoardNote {
  type: string;
  text: string;
  raw?: string;
  loading?: boolean;
  uuid?: string,
  createDate?: number,
  questionText?: string;
}
export interface BoardChatMsg {
  user: AppUserState;
  msg: string;
  sendDate: number;
  uuid: string;
  edited?: boolean;
  editedDate?: number;
}

export enum SearchState {
  NotStarted,
  Loading,
  NoResults,
  ResultsFound,
}

export interface BoardFilter {
  tags?: Tag[];
  keys?: { value: string; }[];
  members?: AppUserState[];
  searchTerm?: string;
}
